module.exports = __webpack_public_path__ + "static/media/people-profile.b7422848.svg";